import React, { Fragment, useEffect, useState } from 'react';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import notes from '../../../assets/notes.svg';
import mitraLogo from '../../../assets/mitra-logo-transparent.svg';
import rightArrow from '../../../assets/right-arrow.svg';
import hiw1 from '../../../assets/hiw1.svg';
import hiw2 from '../../../assets/hiw2.svg';
import hiw3 from '../../../assets/hiw3.svg';
import processStep1Img from '../../../assets/process_step1.svg';
import processStep2Img from '../../../assets/process_step2.svg';
import processStep3Img from '../../../assets/process_step3.svg';
import '../../../styles/components/MitraTelecaller/MitraTelecaller.scss';
import { Carousel } from 'react-responsive-carousel';
import Rating from '../../../components/Shared/Rating';

const MitraTelecaller = () => {
  const [enStrings, setEnStrings] = useState({
    topmostText: 'Earn upto ₹ 10,000 extra',
    headingTxt1: 'Join our team & work as a',
    headingTxt2: 'Tele-Caller',
    ctaTxt: 'Join Our Team',
    processStep1: 'Fill the form & attend a quick 30 minutes training',
    processStep2: 'Work from anywhere with your phone',
    processStep3: 'Earn while waiting for orders or trips',
    hiwHeading: 'How it works?',
    hiwStep1: "Download the 'Knowlarity'",
    hiwStep1_2: 'App from playstore',
    hiwStep2: 'Get your ID & Password and',
    hiwStep2_2: 'start making calls',
    hiwStep3: 'Get paid for every successful call',
    testimonialName: 'Pupun Nayak',
  });

  const [testimonials, setTestimonials] = useState([
    {
      name: 'Pupun Nayak',
      img: require('../../../assets/testimonial_img1.svg'),
      rating: 4,
      txt:
        '"I have been working with Zepto for a while now, I started as a telecaller on mitra so that I can earn extra when I am waiting for orders.  After a 30 min easy training session, I began calling from my phone only, first 2 days I was learning, now i am an expert!"',
    },
  ]);

  const [useStrings, setUseStrings] = useState();

  const [renderDisplay, setRenderDisplay] = useState(false);

  useEffect(() => {
    setUseStrings(enStrings);
    setRenderDisplay(true);
  }, []);

  return (
    <Fragment>
      {renderDisplay ? (
        <div className="parent-cont">
          <div className="topmost-content disp-flex-col aic">
            <div className="note-img-div">
              <img className="note-img" src={notes} />
            </div>
            <div className="topmost-txt">{useStrings.topmostText}</div>
          </div>

          <div className="heading-cont disp-flex-col aic">
            <div className="heading-img-div">
              <img className="heading-img" src={mitraLogo} />
            </div>

            <div className="heading-txt1">{useStrings.headingTxt1}</div>

            <div className="heading-txt2">{useStrings.headingTxt2}</div>
          </div>

          <div className="cta-parent-div disp-flex-col aic jcc">
            <a
              href="https://bit.ly/mitra-tele"
              target="_blank"
              rel="noopener noreferrer"
              className="cta-div w-90"
            >
              <div className="disp-flex jcc aic">
                <div className="cta-txt">{useStrings.ctaTxt}</div>
              </div>
            </a>
          </div>

          <div className="process-parent-div disp-flex-col aic jcc">
            <div className="process-div disp-flex aib jcsb w-90">
              <div className="process-step1 disp-flex-col aic jcc pro-common">
                <div className="process-step1-img-div pro-img-div">
                  <img className="process-step1-img pro-img" src={processStep1Img} />
                </div>

                <div className="process-step1-txt pro-txt">{useStrings.processStep1}</div>
              </div>

              <div className="process-arrow-parent">
                <img className="process-arrow-img" src={rightArrow} />
              </div>

              <div className="process-step2 disp-flex-col aic jcc pro-common">
                <div className="process-step2-img-div pro-img-div">
                  <img className="process-step2-img pro-img" src={processStep2Img} />
                </div>

                <div className="process-step2-txt pro-txt">{useStrings.processStep2}</div>
              </div>

              <div className="process-arrow-parent">
                <img className="process-arrow-img" src={rightArrow} />
              </div>

              <div className="process-step3 disp-flex-col aic jcc pro-common">
                <div className="process-step3-img-div pro-img-div">
                  <img className="process-step3-img pro-img" src={processStep3Img} />
                </div>

                <div className="process-step3-txt pro-txt">{useStrings.processStep3}</div>
              </div>
            </div>
          </div>

          <div className="hiw-parent-div disp-flex-col jcc aic">
            <div className="hiw-div disp-flex-col aic w-90">
              <div className="hiw-heading-txt">{useStrings.hiwHeading}</div>

              <div className="hiw-step1 disp-flex-col aic hiw-common-div">
                <div className="hiw1-img-div">
                  <img className="hiw1-img hiw-step-common-img" src={hiw1} />
                </div>

                <div className="hiw1-txt hiw-step-common-txt">{useStrings.hiwStep1}</div>
                <div className="hiw1_2-txt hiw-step-common-txt">{useStrings.hiwStep1_2}</div>
              </div>

              <div className="hiw-step2 disp-flex-col aic hiw-common-div">
                <div className="hiw2-img-div">
                  <img className="hiw2-img hiw-step-common-img" src={hiw2} />
                </div>

                <div className="hiw2-txt hiw-step-common-txt">{useStrings.hiwStep2}</div>
                <div className="hiw2_2-txt hiw-step-common-txt">{useStrings.hiwStep2_2}</div>
              </div>

              <div className="hiw-step3 disp-flex-col aic hiw-common-div">
                <div className="hiw3-img-div">
                  <img className="hiw3-img hiw-step-common-img" src={hiw3} />
                </div>

                <div className="hiw3-txt hiw-step-common-txt">{useStrings.hiwStep3}</div>
              </div>
            </div>
          </div>

          <div className="testimonial-super-parent-div disp-flex-col jcc aic">
            <div className="testimonial-parent-div disp-flex-col jcc aic w-90">
              <Carousel
                showArrows={false}
                showThumbs={false}
                showStatus={false}
                showIndicators={false}
              >
                {testimonials.map((testimonial, index) => (
                  <div className="testimonial-div disp-flex-col aic jcc">
                    <div className="testimonial-img-div">
                      <img
                        className="testimonial-img"
                        key={index}
                        src={testimonial.img}
                        alt={testimonial.name}
                      />
                    </div>

                    <div className="testimonial-name">{testimonial.name}</div>

                    <div className="rating-div">
                      <Rating currentRating={testimonial.rating} />
                    </div>

                    <div className="testimonial-txt">{testimonial.txt}</div>
                  </div>
                ))}
              </Carousel>
            </div>
          </div>
        </div>
      ) : null}
    </Fragment>
  );
};

export default MitraTelecaller;
